import { InAppBrowserOptions } from '@app/core/services/in-app-browser/in-app-browser.service';

export const CONFIG = {
  "CLOUD_STORAGE" : "CloudStorage",
  "DOMAIN" : "Domain",
  "EMAIL_OPTION" : "EmailOption",
  "FILE_OPTION" : "FileOption",
  "LOCK_LOCATION_CHANGE" : "LockLocationChange",
  "PICTURE_OPTION" : "PictureOption",
  "QR_SCANNING" : "QRScanning"
}

export const IN_APP_BROWSER_OPT: InAppBrowserOptions = {
  clearCache: false,
  clearCookies: false
};
